import App from './components/App';
// Import the css styles
// These were isolated from the old Bootstrap based theme
// And are now namespaced within .frank-app
import './styles/icons-custom.css';
import './styles/icons-font-awesome.css';
import './styles/layout.css';
import './styles/print.css';
import ReactDOM from 'react-dom/client';

const root = document.getElementById('root');
const config = JSON.parse(root.getAttribute('data-config'));
ReactDOM.createRoot(root).render(<App config={config} />);
